import { axs } from './config/axiosConfig';
import { BASE_API_URL } from 'lib/setting';

const basePath = `${BASE_API_URL}/project`;

export function initProject(payload: object | any) {
  return axs({ url: `${basePath}/init`, method: 'get', params: payload });
}

// ?page=1&keyword&stages=1%6&startDate&endDate
export function fetchProjects(payload: object | any) {
  return axs({ url: `${basePath}`, method: 'get', params: payload });
}

// projectCode
export function fetchProject(id: string) {
  return axs({ url: `${basePath}/${id}`, method: 'get' });
}

// projectCode
export function createProject(payload: object | any) {
  return axs({ url: `${basePath}`, method: 'post', data: payload });
}

export function editProject({ projectCode, data }: { projectCode: string; data: object | any }) {
  return axs({ url: `${basePath}/${projectCode}`, method: 'put', data: data });
}

// projectCode
export function deleteProject({ projectCode }: { projectCode: string }) {
  return axs({ url: `${basePath}/${projectCode}`, method: 'delete' });
}

export function editTimeline(payload: { projectCode: string; stage: number }) {
  return axs({ url: `${basePath}/timeline`, method: 'put', data: payload });
}

// ?page=1&keyword&stages=0%6&startDate&endDate
export function fetchReworkProjects(payload: {
  page: number;
  keyword: string;
  stages: string;
  startDate?: number;
  endDate?: number;
}) {
  return axs({ url: `${basePath}/rework`, method: 'get', params: payload });
}

// projectCode
export function fetchCopyProject(id: string) {
  return axs({ url: `${basePath}/copy/${id}`, method: 'get' });
}

// NOTE: 사용X
export function fetchProjectFiles(payload: { projectCode: string }) {
  return axs({ url: `${basePath}/file`, method: 'get', params: payload });
}

export function fetchProjectHistories({ id, data }: { id: string; data: { page: number } }) {
  return axs({ url: `${basePath}/history/${id}`, method: 'get', params: data });
}

// projectCode, eventType, params
export function createProjectHistory(payload: {
  projectCode: string;
  eventType: string;
  params: any;
}) {
  return axs({ url: `${basePath}/history`, method: 'post', data: payload });
}

export function createProjectSync(payload: {
  projectCode: string;
  partnerGroupIdx: number;
  cloudDataList: number[];
}) {
  return axs({ url: `${basePath}/sync`, method: 'post', data: payload });
}

export function editProjectSync(payload: {
  projectCode: string;
  syncStatus: number;
  ownerSyncUid: string;
}) {
  return axs({ url: `${basePath}/sync`, method: 'put', data: payload });
}

export function resetProjectSync({
  projectCode,
  data,
}: {
  projectCode: string;
  data: { partnerGroupIdx: number };
}) {
  return axs({ url: `${basePath}/sync/${projectCode}`, method: 'delete', data: data });
}

export function editProjectPartnerManager({
  projectCode,
  data,
}: {
  projectCode: string;
  data: { employeeIdx: number };
}) {
  return axs({ url: `${basePath}/partner/employee/${projectCode}`, method: 'put', data: data });
}

export function editProjectRework({
  projectCode,
  data,
}: {
  projectCode: string;
  data: { reworkType: number[] };
}) {
  return axs({ url: `${basePath}/reworktype/${projectCode}`, method: 'put', data: data });
}

export function fetchPartnerIndication(payload: { client: number; alias: string }) {
  return axs({ url: `${basePath}/indication`, method: 'get', params: payload });
}

export function fetchChatFile({ projectCode }: { projectCode: string }) {
  return axs({ url: `${basePath}/${projectCode}/chatimage`, method: 'get' });
}
export function uploadChatFile({
  projectCode,
  data,
}: {
  projectCode: string;
  data: { images: any; socketId: string };
}) {
  return axs({ url: `${basePath}/${projectCode}/chatimage`, method: 'post', data: data });
}

export function editChatFile({
  projectCode,
  data,
}: {
  projectCode: string;
  data: { image: any; chatId: string; imageId: string; socketId: string };
}) {
  return axs({ url: `${basePath}/${projectCode}/chatimage`, method: 'put', data: data });
}

export function deleteChatFile({
  projectCode,
  data,
}: {
  projectCode: string;
  data: { chatId: string };
}) {
  return axs({ url: `${basePath}/${projectCode}/chatimage`, method: 'delete', data: data });
}

export function clearChatAll({ projectCode }: { projectCode: string }) {
  return axs({ url: `${basePath}/${projectCode}/allchatimage`, method: 'delete' });
}
